import React from "react";
import { Link } from "react-router-dom";

export default function BrandSettingHeader({ toggleSidebar }) {
  return (
    <div className="mainHead d-flex align-items-center justify-content-between pt-3 py-3">
      <div className="headText ms-3">
        <p>Brand Settings</p>
      </div>
      {/* <span className="text-white mb-0" style={{ fontSize: 13 }}>
        Manage brands for each transaction section.
      </span> */}

      <div className="headIcons d-flex me-3">
        <div className="iconMain" onClick={toggleSidebar}>
          <i className="fa-solid fa-bars"></i>
        </div>
      </div>
    </div>
  );
}
